export default (props) => (
  <svg {...props} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M8.062 15a.999.999 0 01-.703-.288L3.297 10.71a1 1 0 111.405-1.422l3.353 3.299 7.235-7.294a1 1 0 111.419 1.411l-7.937 8a1.002 1.002 0 01-.71.295"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
